"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var CreditCardFormToggleButton = /** @class */ (function (_super) {
    tslib_1.__extends(CreditCardFormToggleButton, _super);
    function CreditCardFormToggleButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreditCardFormToggleButton.prototype.render = function () {
        return (React.createElement("a", { className: this.props.classes, onClick: this.props.onClick }, this.props.buttonText));
    };
    return CreditCardFormToggleButton;
}(React.Component));
exports.default = CreditCardFormToggleButton;
//# sourceMappingURL=credit_card_form_toggle_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/onboarding/credit_card_form_toggle_button.js
// module id = NaxH
// module chunks = 20 21